import { Outlet, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, GraduationCap, Settings } from "lucide-react";

export default function ParentLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-slate-900 text-white border-b border-slate-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <Link to="/veli" className="flex items-center gap-2" data-testid="parent-brand">
            <div className="w-8 h-8 rounded-lg bg-[#FF6B6B] flex items-center justify-center">
              <GraduationCap className="w-4 h-4" />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-bold text-sm">Ela AI Akademi</div>
              <div className="text-[10px] text-slate-400">Veli Paneli</div>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/veli/ayarlar" data-testid="parent-settings-link"
              className="p-2 rounded-lg hover:bg-slate-800 text-slate-200">
              <Settings className="w-4 h-4" />
            </Link>
            <span className="text-sm text-slate-200 hidden sm:inline">{user?.full_name}</span>
            <button onClick={logout} data-testid="parent-logout-btn"
              className="p-2 rounded-lg hover:bg-slate-800 text-slate-200">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
